import { MoengageInstance } from '@services/moengage-service';
import { Component, Event, EventEmitter, h, Host, Prop, State } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { If } from '@utils/If';
import { CANCEL_LOGIN, SIGNIN, SIGNUP, SKIP_USER_DETAILS, USER_DETAILS } from '../../../utils/moengage-event-keys';
@Component({
  tag: 'auth-flow',
  styleUrl: 'auth-flow.scss',
  shadow: true
})
export class AuthFlow {
  @Prop() isLoginRequired: boolean = false;
  @State() otpValidated: boolean = false;
  @Event({ bubbles: false }) success: EventEmitter<any>;
  @Event({ bubbles: false }) cancel: EventEmitter<any>;
  @State() open: boolean = true;
  @State() loginId: string = '';
  @State() mobileNumber: string = '';
  @State() loginDetails: any = {};

  onVerifyCustomer = (event: any) => {
    event.stopPropagation();
    const { detail } = event;
    if (detail.newCustomer || detail.guestLogin) {
      this.loginDetails = detail;
      this.otpValidated = true;
      this.mobileNumber = detail.mobileNumber;
      MoengageInstance.trackAuthEvent(SIGNUP, {
        "hashed_mobile": detail.hashed_mobile
      })
    } else {
      const ccustomer = detail?.customerCards?.[0] || {};
      MoengageInstance.trackAuthEvent(SIGNIN, {
        "hashed_mobile": detail.hashed_mobile,
        "program_name": ccustomer?.cardType || 'SMARTBUY',
        "sub_program": ccustomer?.subProgram || ''
      })
      this.open = false;
      setTimeout(() => {
        this.success.emit({ ...detail, authenticated: true });
      }, 1000);
    }
  };

  onCustomerDetailsSuccess = (event: any) => {
    event.stopPropagation();
    this.open = false;
    MoengageInstance.trackAuthEvent(USER_DETAILS, {
      "name": event.detail.name,
      "hashed_mobile": event.detail?.hashed_mobile,
      "program_name": event.detail?.programName || 'SMARTBUY',
    })
    setTimeout(() => {
      this.success.emit({ ...this.loginDetails, ...event.detail });
    }, 1000);
  };

  onCustDetailsSkip = (event: any) => {
    event.stopPropagation();
    this.open = false;
    MoengageInstance.trackAuthEvent(SKIP_USER_DETAILS, this.loginDetails)
    setTimeout(() => {
      this.cancel.emit({ ...this.loginDetails, skipDetails: true });
    }, 1000);
  };

  onLoginCanel = (event: any) => {
    event.stopPropagation();
    this.open = false;
    MoengageInstance.trackEvent(CANCEL_LOGIN, {})
    setTimeout(() => {
      this.cancel.emit({});
    }, 1000);
  };

  onPoupClose = (event: any) => {
    event.stopPropagation();
    this.open = false;
    if (this.loginDetails?.customer_id) {
      this.onCustDetailsSkip(event);
    } else {
      this.onLoginCanel(event);
    }
  };

  render() {
    const assetPath = pathStore.assetPath;
    return (
      <Host>
        <popup-modal escapeClose onPopupClose={this.onPoupClose} open={this.open} size="2xl">
          <div class="flex flex-col md:grid grid-cols-[calc(45%_-_1rem)_calc(55%_-_1rem)] gap-x-8 bg-white p-6 md:p-8">
            <div class="rounded-md hidden md:flex flex-col items-center px-4 py-5 login-promo">
              <div class="flex gap-1 items-center w-full">
                <img class="h-[20px]" src={`${assetPath}icons/brand-icon.svg`} />
                <img class="h-[20px]" src={`${assetPath}images/Smartbuylogo.png`} />
              </div>
              <div class="mt-4 text-white font-medium">
                Upto <span class="text-yellow-300">10X Reward Points / 10% Cashback</span> with HDFC Bank <br /> Cards and EasyEMI
              </div>
              <img class="mt-4 min-h-[130px] w-[80%]" src={`${assetPath}images/customer-signin.svg`} />
            </div>
            <div class="grow-1">
              <If condition={!this.otpValidated} children={<login-flow isLoginRequired={this.isLoginRequired} onCancel={this.onLoginCanel} onSuccess={this.onVerifyCustomer} class="h-full" />} />
              <If
                condition={this.otpValidated}
                children={
                  <div class="md:max-h-120 overflow-scroll no-scrollbar">
                    <customer-details
                      loginDetails={this.loginDetails}
                      assetPath={assetPath}
                      loginId={this.loginId}
                      mobileNumber={this.mobileNumber}
                      onSuccess={this.onCustomerDetailsSuccess}
                      onSkip={this.onCustDetailsSkip}
                    />
                  </div>
                }
              />
            </div>
          </div>
        </popup-modal>
      </Host>
    );
  }
}
